import { AccordionContent } from '@radix-ui/react-accordion';
import { Button } from 'front-commons/ds';
import styled, { css } from 'styled-components';

export const SeeMoreTrigger = styled(Button)<{
	open: boolean;
}>`
	height: initial;
	gap: 0.25rem;

	p {
		font-size: 0.875rem;
		font-weight: 600;
	}

	${({ open }) =>
		open &&
		css`
			i {
				rotate: 180deg;
				transition: rotate 0.3s;
			}
		`}
`;

export const SeeMoreContent = styled(AccordionContent)`
	&[data-state='open'] {
		animation: slideDown 300ms cubic-bezier(0.87, 0, 0.13, 1);
	}

	&[data-state='closed'] {
		animation: slideUp 300ms cubic-bezier(0.87, 0, 0.13, 1);
	}

	@keyframes slideDown {
		from {
			height: 0;
		}
		to {
			height: var(--radix-accordion-content-height);
		}
	}

	@keyframes slideUp {
		from {
			height: var(--radix-accordion-content-height);
		}
		to {
			height: 0;
		}
	}
`;
